import React, { useState } from 'react';
import { CheckboxInput, Container, StyledSpan } from './Checkbox.styles';

interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange: (checked?: boolean) => void;
  className?: string;
}

const Checkbox = ({ label, checked, onChange, className }: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.target.checked;
    onChange(checked);
    setIsChecked(checked);
  }

  return (
    <Container className={className}>
      <CheckboxInput type="checkbox" checked={isChecked} onChange={handleOnChange} />
      {label && <StyledSpan type="span">{label}</StyledSpan>}
    </Container>
  );
};

export default Checkbox;
